import { groupBy } from 'lodash';
import { Box } from '@mui/material';
import { toastConfig } from 'config';
import { App, Spin } from 'antd';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { TableStatusMap } from 'pages/globals/global';
import controls from 'assets/images/icons/deactivated.svg';
import ServiceLevelEditModal from './ServiceLevelEditModal';
import ComptrollerConfirmModal from '../ComptrollerConfirmModal';
import ComptrollerDataTable from '../comptroller-table/ComptrollerDataTable';
import { useActivationEntityMutation } from 'store/features/process/processApi';
import { timelineBasisData } from './Create';

function ListViewService({ setReloadTable, tableData = [], isLoading, existingEntity, existingName, options }) {
	const { message: messageApi } = App.useApp();
	const [value, setValue] = useState(null);
	const [modalData, setModalData] = useState({});
	const [filterData, setFilterData] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [submitData, setSubmitData] = useState(null);
	const [submitForm, setSubmitForm] = useState(false);
	const [rowSelection, setRowSelection] = useState({});
	const [actionValue, setActionValue] = useState(null);
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);

	const [type, setType] = useState('View');
	const [editItem, setEditItem] = useState(null);

	const { profileData } = useSelector((state) => state?.profile);

	const [ActivationEntity, { data: activationEntity }] = useActivationEntityMutation();

	const activeDeactiveHandle = (entityStatus) => {
		let arr = [];

		if (entityStatus === 'Active') {
			setValue('Inactive');
			setActionValue('deactivated');
			setModalData({
				head: 'Entity',
				label:
					rowSelection?.length > 1 ? (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>deactivate</b> all?
						</p>
					) : (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>deactivate</b> this entity?
						</p>
					),
			});

			if (selectedRowKeys[entityStatus]) {
				selectedRowKeys[entityStatus]?.map((item) => {
					arr.push({
						id: item?.id,
						code: item?.code,
						name: item?.name,
						entityStatus: 'Inactive',
						parent: item?.parent ?? '',
						companyCode: profileData?.creatorOrganizationId,
					});

					return item;
				});
			}
		} else if (entityStatus === 'Inactive') {
			setValue('Active');
			setActionValue('activated');
			setModalData({
				head: 'Entity',
				label:
					rowSelection?.length > 1 ? (
						<p>
							{' '}
							Do you want to <b style={{ fontSize: '1rem' }}>active</b> all?
						</p>
					) : (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>active</b> this entity?
						</p>
					),
			});

			if (selectedRowKeys[entityStatus]) {
				selectedRowKeys[entityStatus]?.map((item) => {
					arr.push({
						id: item?.id,
						code: item?.code,
						name: item?.name,
						entityStatus: 'Active',
						parent: item?.parent ?? '',
						companyCode: profileData?.creatorOrganizationId,
					});

					return item;
				});
			}

			if (selectedRowKeys['Onboarded']) {
				selectedRowKeys['Onboarded']?.map((item) => {
					arr.push({
						id: item?.id,
						code: item?.code,
						name: item?.name,
						entityStatus: 'Active',
						parent: item?.parent ?? '',
						companyCode: profileData?.creatorOrganizationId,
					});

					return item;
				});
			}
		}
		if (arr?.length !== rowSelection?.length) {
			messageApi.error({
				content: 'Your request is inconsistent with selection.',
				icon: <img src={controls} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
			});
		} else {
			setSubmitData(arr);
			setShowModal(true);
		}
	};

	useEffect(() => {
		if (rowSelection?.length) {
			let arr = [];

			rowSelection?.forEach((item) => {
				arr.push(item.original);
			});

			setSelectedRowKeys(groupBy(arr, ({ entityStatus }) => entityStatus));
		}
	}, [rowSelection]);

	useEffect(() => {
		if (submitData && submitForm) {
			submitData?.forEach((item) => {
				ActivationEntity(item);
			});
		}
	}, [submitForm]);

	useEffect(() => {
		if (activationEntity && value === activationEntity?.entityStatus) {
			let message =
				submitData?.length > 1 ? `Success! ${submitData?.length} rows ${actionValue}` : `Success! ${submitData?.length} row ${actionValue}`;

			toast.success(message, toastConfig);

			setReloadTable((val) => !val);
			setSubmitForm(false);
			setSubmitData(null);
		} else if (activationEntity && value !== activationEntity?.entityStatus) {
			toast.error('Entity Status Updation Error!', toastConfig);
		}
	}, [activationEntity]);

	const activeInactiveStatus = (status) => {
		if (status === 'Active') {
			return (
				<Box
					style={{
						// backgroundColor: '#DBF7E2', color: '#30653D',
						textAlign: 'center',
						borderRadius: '5px',
						padding: '2px',
					}}
				>
					{TableStatusMap[status]}
				</Box>
			);
		} else if (status === 'Inactive') {
			return (
				<Box
					style={{
						// backgroundColor: '#FFE2E2', color: '#BB2222',
						textAlign: 'center',
						borderRadius: '5px',
						padding: '2px',
					}}
				>
					{TableStatusMap[status]}
				</Box>
			);
		} else if (status === 'W-I-P') {
			return (
				<Box
					style={{
						// backgroundColor: '#FDF7C4', color: '#694500',
						textAlign: 'center',
						borderRadius: '5px',
						padding: '2px',
					}}
				>
					{TableStatusMap[status]}
				</Box>
			);
		}
	};

	const COLUMNS = useMemo(
		() => [
			{
				Header: 'Task Nature',
				accessor: 'taskType',
			},
			{
				Header: 'Timeline Basis',
				accessor: (data) => {
					return timelineBasisData?.find((item) => item?.value === data?.dayCount)?.label ?? null;
				},
			},
			{
				Header: 'SLA Triggering Action',
				accessor: 'action',
			},
			{
				Header: 'Code',
				accessor: 'code',
			},
			{
				// align: 'center',
				Header: 'Status',
				cellAlign: 'center',
				accessor: (data) => {
					return TableStatusMap[data?.activationStatus];
				},
				Cell: (cell) => {
					return activeInactiveStatus(TableStatusMap[cell.row.original.activationStatus]);
				},
			},
			// {
			//   align: "center",
			//   Header: "Action",
			//   disableSortBy: "true",
			//   Cell: (cell) => (
			//     <div style={{ textAlign: "center" }}>
			//       <Tooltip title="View">
			//         <Button
			//           type="text"
			//           icon={<img src={viewIcon} width={16} height={16} alt="view" />}
			//           onClick={(e) => {
			//             e.stopPropagation();
			//             navigate("/comptroller/entities/view", { state: { options, entityDetails: cell.row.original, existingEntity, existingName } });
			//           }}
			//         ></Button>
			//       </Tooltip>
			//       <Tooltip title="Edit">
			//         <Button
			//           type="text"
			//           icon={<img src={editIcon} width={16} height={16} alt="edit" />}
			//           onClick={(e) => {
			//             e.stopPropagation();

			//             setEditItem(cell.row.original);

			//             // navigate("/comptroller/entities/edit", { state: { options, entityDetails: cell.row.original, existingEntity, existingName } });
			//           }}
			//         ></Button>
			//       </Tooltip>

			//       {/* <Tooltip title="Delete">
			//         <Button
			//           type="text"
			//           icon={<img src={deleteIcon} width={16} height={16} alt="delete" />}
			//           onClick={(e) => {
			//             e.stopPropagation();
			//           }}
			//         ></Button>
			//       </Tooltip> */}
			//     </div>
			//   ),
			// },
		],
		[options, existingEntity, existingName]
	);

	return (
		<Spin spinning={isLoading}>
			<ComptrollerDataTable
				COLUMNS={COLUMNS}
				balkAction={false}
				DATA={tableData}
				xlsxFileName="entity"
				headerColumnSlotId="comptroller-page-columns-slot"
				headerActionSlotId="comptroller-page-export-slot"
				rowSelection={rowSelection}
				setFilterData={setFilterData}
				setRowSelection={setRowSelection}
				activeDeactivateHandle={activeDeactiveHandle}
				onClickHandler={(row) => {
					setEditItem(row);
				}}
			/>

			{showModal && (
				<ComptrollerConfirmModal showModal={showModal} setShowModal={setShowModal} setSubmitForm={setSubmitForm} modalData={modalData} />
			)}

			{editItem && (
				<ServiceLevelEditModal
					type={type}
					options={options}
					setType={setType}
					editItem={editItem}
					dataList={filterData}
					setEditItem={setEditItem}
					existingName={existingName}
					setReloadTable={setReloadTable}
					showModal={editItem ? true : false}
				/>
			)}
		</Spin>
	);
}

export default ListViewService;
